import React, { useState, useContext, useEffect } from 'react'
import { LinearProgress } from '@material-ui/core'
import TopBarLogo from './topBarLogo'
import { Context } from '../Store'

const Header = () => {
  const [state] = useContext(Context)
  const step = state.current_step
  const totalSteps = 4
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    setProgress(((step) / totalSteps) * 100)
  }, [step, totalSteps])
  
  return (
    <div className="fixed w-full top-0 left-0 shadow-md z-50">
      <TopBarLogo />
      <LinearProgress variant="determinate" value={progress} />
    </div>
  )
}

export default Header
